const RESPONSIVE_IMAGE_STEMS = {
  "media/images/Werkhoeken.jpg": "Werkhoeken",
  "media/images/groep3_tekstenenthema.jpg": "groep3_tekstenenthema",
  "media/images/zelfwerkpakken-.jpg": "zelfwerkpakken-",
  "media/images/uitdaging-groep8.jpeg": "uitdaging-groep8",
  "media/images/KindenKijktafel.jpg": "KindenKijktafel",
  "media/images/Levendrekenen2.jpg": "Levendrekenen2",
  "media/images/werkhoeken3.jpg": "werkhoeken3",
  "media/images/_MG_1280.JPG": "_MG_1280",
  "media/images/gezondeschool.jpg": "gezondeschool",
  "media/images/stichtLogo.png": "stichtLogo",
  "media/images/perenfeest.JPG": "perenfeest",
  "media/images/inhetnieuws_kleuteruni.png": "inhetnieuws_kleuteruni",
  "media/images/PrikkelsCoverfoto.png": "PrikkelsCoverfoto",
};

export function getResponsiveImageKeys(s3Key) {
  const key = typeof s3Key === "string" ? s3Key.trim().replace(/^\/+/, "") : "";
  const stem = RESPONSIVE_IMAGE_STEMS[key];
  if (!stem) return null;

  return {
    small: `media/images/responsive/${stem}-480.webp`,
    large: `media/images/responsive/${stem}-960.webp`,
  };
}
